import { datalabHttp } from '@dbl/services/common';

import type { IGameConfigItemDto, IGameItemDto } from './types';

/**
 * 获取游戏列表（主页/左侧游戏选择器）。
 *
 * 接口：`POST /api/v1/datalab/userMessage`；存量：`getGameList` @ `services/global.ts`。
 */
export const getGameList: () => Promise<IGameItemDto[]> = () =>
  datalabHttp({
    url: '/api/v1/datalab/userMessage',
    method: 'post',
  });

/**
 * 获取最近查看的游戏（最近浏览/我的游戏）。
 *
 * 接口：`POST /api/v1/datalab/navigation_recent_view`；存量：`getRecentViewd`。
 */
export const getRecentViewd: () => Promise<unknown> = () =>
  datalabHttp({
    url: '/api/v1/datalab/navigation_recent_view',
    method: 'post',
  });

/**
 * 获取探索分析游戏配置列表。
 *
 * 接口：`POST /api/v1/datalab/getExploreAnalysisGames`；存量：`getGameConfig`。
 */
export const getGameConfig: () => Promise<IGameConfigItemDto[]> = () =>
  datalabHttp({
    url: '/api/v1/datalab/getExploreAnalysisGames',
    method: 'post',
    formatData: (
      data: { game_list?: IGameConfigItemDto[] },
    ): IGameConfigItemDto[] => data.game_list ?? [],
  });
